import { INPUT_TYPE } from '@components/dragableTableFrom/formItems';
import { FORM_KEYS } from './form.keys';
import { VALUEDRIVER_OPTIONS } from '@model';

export const INPUT_MAP = {
  [FORM_KEYS.DEN.key]: {
    inputType: INPUT_TYPE.NUMBER,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.DEN.label} is required`,
      },
    ],
  },
  [FORM_KEYS.CLIENT_EBITDA.key]: {
    inputType: INPUT_TYPE.VALUE_DRIVER_NUMBER,
    rules: [
      {
        required: true,
        message: `This value is required`,
      },
    ],
  },
  [FORM_KEYS.TARGET_EBITDA.key]: {
    inputType: INPUT_TYPE.VALUE_DRIVER_NUMBER,
    rules: [
      {
        required: true,
        message: `This value is required`,
      },
    ],
  },
  [FORM_KEYS.TYPE.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.TYPE.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.TYPE.key,
    options: VALUEDRIVER_OPTIONS,
    optionResetKeys: [
      [FORM_KEYS.TABLE_WRAPPER.key, FORM_KEYS.SYNERGY.key],
      [FORM_KEYS.TABLE_WRAPPER.key, FORM_KEYS.CATEGORY.key],
    ],
  },
  [FORM_KEYS.HAS_LINK.key]: {
    inputType: INPUT_TYPE.CHECK_BOX,
  },
  [FORM_KEYS.LinkURL.key]: {
    inputType: INPUT_TYPE.INPUT,
    placeholder: FORM_KEYS.LinkURL.placeholder,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.LinkURL.label} is required`,
      },
    ],
  },
  [FORM_KEYS.SYNERGY.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.SYNERGY.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.SYNERGY.key,
    options: VALUEDRIVER_OPTIONS,
    optionDependKey: [FORM_KEYS.TABLE_WRAPPER.key, FORM_KEYS.TYPE.key],
    optionResetKeys: [[FORM_KEYS.TABLE_WRAPPER.key, FORM_KEYS.CATEGORY.key]],
  },
  [FORM_KEYS.CATEGORY.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.CATEGORY.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.CATEGORY.key,
    options: VALUEDRIVER_OPTIONS,
    optionDependKey: [FORM_KEYS.TABLE_WRAPPER.key, FORM_KEYS.SYNERGY.key],
  },
  [FORM_KEYS.DES.key]: {
    inputType: INPUT_TYPE.TEXT,
    maxLength: 180,
  },
  [FORM_KEYS.PROBABILITY.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.PROBABILITY.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.PROBABILITY.key,
    options: VALUEDRIVER_OPTIONS,
  },
  [FORM_KEYS.TIME_TO_ACHIEVE.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.TIME_TO_ACHIEVE.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.TIME_TO_ACHIEVE.key,
    options: VALUEDRIVER_OPTIONS,
  },
  // [FORM_KEYS.FINANCIALIMPACT_SCALE.key]: {
  //   inputType: INPUT_TYPE.SELECT,
  //   rules: [
  //     {
  //       required: true,
  //       message: `${FORM_KEYS.FINANCIALIMPACT_SCALE.label} is required`,
  //     },
  //   ],
  //   optionKey: FORM_KEYS.FINANCIALIMPACT_SCALE.key,
  //   options: VALUEDRIVER_OPTIONS,
  // },
  // [FORM_KEYS.FINANCIALIMPACT_DOLLAR.key]: {
  //   inputType: INPUT_TYPE.VALUE_DRIVER_NUMBER,
  //   rules: [
  //     {
  //       required: true,
  //       message: `${FORM_KEYS.FINANCIALIMPACT_DOLLAR.label} is required`,
  //     },
  //   ],
  // },
  [FORM_KEYS.FINANCIAL_IMPACT.key]: {
    inputType: INPUT_TYPE.SELECT,
    rules: [
      {
        required: true,
        message: `${FORM_KEYS.FINANCIAL_IMPACT.label} is required`,
      },
    ],
    optionKey: FORM_KEYS.FINANCIAL_IMPACT.key,
    options: VALUEDRIVER_OPTIONS,
    inputNumber: true,
  },
  // [FORM_KEYS.ONE_TIME_COST_SCALE.key]: {
  //   inputType: INPUT_TYPE.SELECT,
  //   optionKey: FORM_KEYS.ONE_TIME_COST_SCALE.key,
  //   options: VALUEDRIVER_OPTIONS,
  // },
  // [FORM_KEYS.ONE_TIME_COST_DOLLAR.key]: {
  //   inputType: INPUT_TYPE.VALUE_DRIVER_NUMBER,
  // },
  [FORM_KEYS.ONE_TIME_COST.key]: {
    inputType: INPUT_TYPE.SELECT,
    optionKey: FORM_KEYS.ONE_TIME_COST.key,
    options: VALUEDRIVER_OPTIONS,
    inputNumber: true,
  },
  [FORM_KEYS.DELETE.key]: {
    inputType: INPUT_TYPE.DELETE,
  },
  [FORM_KEYS.DRAG.key]: {
    inputType: INPUT_TYPE.DRAG,
  },
  [FORM_KEYS.RICH_TEXT.key]: {
    inputType: INPUT_TYPE.RICH_TEXT,
    maxLength: 180,
  },
  [FORM_KEYS.RICH_TITLE.key]: {
    inputType: INPUT_TYPE.RICH_TITLE,
  },
};
